import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { invoiceKeys } from '@/lib/queryKeys';
import { invoiceEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api/client';
import { normalizeInvoice } from './useInvoice';
import type { ApplyLateFeeDto, Invoice } from '@/types/invoice';

export function useApplyLateFee() {
  const queryClient = useQueryClient();

  return useApiMutation<Invoice, ApplyLateFeeDto>({
    mutationFn: async ({ id, ...body }) =>
      normalizeInvoice(
        await apiPost<Record<string, unknown>, Omit<ApplyLateFeeDto, 'id'>>(
          operationsClient,
          invoiceEndpoints.applyLateFee(id),
          body,
        ),
      ),
    onSuccess: (data) => {
      queryClient.setQueryData<Invoice>(invoiceKeys.detail(data.id), data);
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.all() });
      toast.success('Late fee applied');
    },
  });
}
